// extracted by mini-css-extract-plugin
export default {"root":"S0zrE0","badge":"NLp5Xi"};